var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcommodation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 22.2073V15.6856C24.6667 15.2319 24.5741 14.7829 24.3946 14.3662C24.215 13.9495 23.9523 13.5738 23.6225 13.2622L17.4783 7.45557C17.1689 7.16301 16.7592 7 16.3333 7C15.9075 7 15.4978 7.16301 15.1883 7.45557L9.04417 13.2622C8.71435 13.5738 8.45163 13.9495 8.27208 14.3662C8.09254 14.7829 7.99995 15.2319 8 15.6856V22.2073C8 22.6493 8.17559 23.0732 8.48816 23.3858C8.80072 23.6983 9.22464 23.8739 9.66667 23.8739H23C23.442 23.8739 23.8659 23.6983 24.1785 23.3858C24.4911 23.0732 24.6667 22.6493 24.6667 22.2073Z",
    stroke: "url(#paint0_linear_3410_9075)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9075",
    x1: 23.3148,
    y1: 7,
    x2: 13.2788,
    y2: 17.4032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcommodation);
export default __webpack_public_path__ + "static/media/acommodation.53baebd1.svg";
export { ForwardRef as ReactComponent };